import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.images = Array.from(this.el.querySelectorAll('img'))
        this.onImageLoadBind = this.onImageLoad.bind(this)

        for(let image of this.images) {
            image.addEventListener('load', this.onImageLoadBind);
        }
    }

    onImageLoad(e) {
        console.log('onImageLoad', e);
        this.call('update', null, 'Scroll');
    }

    destroy() {
        for(let image of this.images) {
            image.removeEventListener('load', this.onImageLoadBind);
        }
    }
}
